export default __webpack_public_path__ + "static/media/1926.f7d87a21.png";